// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__TL9Uz","separator":"Footer_separator__dBIYf"};